<template>
    <div>
        <!--
        {{ tokenExpMs }}
        <div class="app" v-if="authLocked">
            <div class="app-body">
                <Sidebar :navItems="nav"/>
                <main class="main">
                    <breadcrumb :list="list" v-if="this.$store.state.authenticated"></breadcrumb>
                    <div class="container-fluid">
                        <div class="row justify-content-center">
                            <div class="col-md-4 text-center">
                                <div class="card">
                                    <div class="card-header">
                                        <i class="fa fa-lock fa-5x m-0" aria-hidden="true"></i>
                                    </div>
                                    <div class="card-body">
                                        <router-link class="btn btn-primary btn-block" tag="button" :to="{ name: 'HomeReception' }">Recepce</router-link>
                                          <router-link class="btn btn-primary btn-block" tag="button" :to="{ name: 'HomeDoctor', params: { doctorid: 1 }}">Přihlášení doktora 1</router-link>
                                          <router-link class="btn btn-primary btn-block" tag="button" :to="{ name: 'HomeDoctor', params: { doctorid: 2 }}">Přihlášení doktora 2</router-link>
                                        <form @submit.prevent="submitReloginForm">
                                            <div class="h3"></div>
                                            <div class="form-group">
                                                <label for="exampleInputPassword1">Heslo</label>
                                                <input v-model="password" type="password" class="form-control" id="exampleInputPassword1" placeholder="Heslo">
                                                <small id="passwordError" class="form-text text-danger" v-if="loginError">{{ loginError.password }}</small>
                                            </div>
                                            <div class="form-group" v-if="pinExpTime !== false">
                                                <div class="form-group">
                                                <label for="inputPIN_0">PIN</label>
                                                <div class="row justify-content-between m-0">
                                                    <input v-model="user.pin_0" maxlength="1" type="text" style="width: 2.5rem; font-size: 2rem; text-align: center" class="" @keyup.delete="deletePIN(0, $event)" @click="selectAll(0)" @keyup="writePIN(0, $event)" autofocus id="inputPIN_0" placeholder="">
                                                    <input v-model="user.pin_1" maxlength="1" type="text" style="width: 2.5rem; font-size: 2rem; text-align: center" class="" @keyup.delete="deletePIN(1, $event)" @click="selectAll(1)" @keyup="writePIN(1, $event)" id="inputPIN_1" placeholder="">
                                                    <input v-model="user.pin_2" maxlength="1" type="text" style="width: 2.5rem; font-size: 2rem; text-align: center" class="" @keyup.delete="deletePIN(2, $event)" @click="selectAll(2)" @keyup="writePIN(2, $event)" id="inputPIN_2" placeholder="">
                                                    <input v-model="user.pin_3" maxlength="1" type="text" style="width: 2.5rem; font-size: 2rem; text-align: center" class="" @keyup.delete="deletePIN(3, $event)" @click="selectAll(3)" @keyup="writePIN(3, $event)" id="inputPIN_3" placeholder="">
                                                    <input v-model="user.pin_4" maxlength="1" type="text" style="width: 2.5rem; font-size: 2rem; text-align: center" class="" @keyup.delete="deletePIN(4, $event)" @click="selectAll(4)" @keyup="writePIN(4, $event)" id="inputPIN_4" placeholder="">
                                                </div>
                                                <small id="pinError" class="form-text text-danger" v-if="loginError">{{ loginError.pin }}</small>
                                                <small id="pinError" class="form-text text-danger" v-if="pinExpTime">{{ pinRemainingTime }}</small>
                                            </div>
                                            <div class="form-check">
                                              <label class="form-check-label">
                                                <input type="checkbox" class="form-check-input">
                                                Check me out
                                              </label>
                                            </div>
                                            <button type="submit" id="submitRelogin" class="btn btn-primary">Odemknout</button>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
                <AppAside/>
            </div>
            <AppFooter/>
        </div> -->
        <!--<re-login-modal :opened="true" @relogin-done="reloginDone"></re-login-modal>-->
        <div class="app" :class="authLocked === true ? 'blured-5px' : ''">
            <AppHeader :list="list" @lock="setAuthLock" v-if="isAuthenticated"></AppHeader>
            <div class="app-body" :class="impersonating ? 'impersonating-offset' : ''">
                <!--<Sidebar :navItems="nav"/>-->
                <main class="main">
                    <!--<breadcrumb :list="list" v-if="this.$store.state.authenticated"></breadcrumb>-->
                    <div class="container-fluid">
                      <router-view></router-view>
                    </div>
                </main>
                <AppAside/>
            </div>
            <AppFooter/>
        </div>
    </div>
</template>

<script>
  import nav from '../_nav'
  import { Header as AppHeader, Sidebar, Aside as AppAside, Footer as AppFooter, Breadcrumb } from '../components/'

  export default {
    name: 'full',
    components: {
      AppHeader,
      Sidebar,
      AppAside,
      AppFooter,
      Breadcrumb
      // ReLoginModal
    },
    data () {
      return {
        needReLogin: false,
        nav: nav.items,
        authLocked: false,
        password: '',
        lockTimeout: false,
        tokenExpMs: this.$ls.get('token_exp_ms')
      }
    },
    methods: {
      reloginDone () {
        this.authLocked = false
        this.$ls.set('locked', false)
        this.$router.go({
          path: this.$router.path,
          query: {
            t: +new Date()
          }
        })
      },
      setAuthLock () {
        // this.authLocked = true
      },
      unlock () {
        this.$ls.set('locked', false)
        // this.authLocked = false
      },
      submitReloginForm () {
        this.unlock()
      },
      authChanged (val, oldVal, uri) {
        if (val === null && oldVal === true) {
          this.$router.push({name: 'Login'})
        }
      },
      autoLogout (val, oldVal, uri) {
        if (val > 0) {
          // clearTimeout(this.lockTimeout)
          // console.log('zamkne se za ' + val + ' milisekund')
          // this.lockTimeout = setTimeout(() => {
          // this.$ls.set('locked', true)
          // }, val)
        }
      },
      showModal (name) {
        this.$modal.show(name)
      },
      hideModal (name) {
        this.$modal.hide(name)
      },
      lock (val, oldVal, uri) {
        if (val === true) {
          this.authLocked = true
        } else {
          this.authLocked = false
        }
      }
    },
    computed: {
      name () {
        return this.$route.name
      },
      list () {
        return this.$route.matched
      },
      isAuthenticated () {
        return this.$ls.get('authenticated')
      },
      impersonating () {
        return this.$ls.get('impersonating') === true
      }
    },
    watch: {
      authLocked (val) {
        if (val === true) {
          // console.log('jo uz otaviram modal')
          this.showModal('re-login-modal')
        } else {
          this.hideModal('re-login-modal')
        }
      }
    },
    mounted () {
      this.$http.interceptors.response.use(response => {
        return response
      }, error => {
        // console.log(error.response)
        if (error.response.status === 401) {
          if (error.response.data.error.token_locked === true) {
            // console.log('zamknu TO !!')
            this.authLocked = true
            this.$ls.set('locked', true)
          } else if (error.response.data.error.token_expired === true) {
            this.authLocked = false
            this.$ls.remove('token')
            this.$ls.remove('authenticated')
            this.$ls.remove('role')
            this.$ls.remove('fullname')
            this.$ls.remove('userid')
            this.$ls.remove('locked')
            this.$router.push({name: 'Login'})
          }
        /* } else {
          return error */
        }
        return Promise.reject(error)
        // return error.response
      })
      this.$ls.on('authenticated', this.authChanged)
      this.$ls.on('token_exp_ms', this.autoLogout)
      this.$ls.on('locked', this.lock)
      if (this.$ls.get('locked') === true) {
        this.authLocked = true
      }
    }
  }
</script>

<style scoped>
  .app-body {
    margin-top: 110px !important;
  }

  .app-body.impersonating-offset {
    margin-top: 160px !important;
  }

  /*
  .blured-5px {
      -webkit-filter: blur(5px);
      -moz-filter: blur(5px);
      -o-filter: blur(5px);
      -ms-filter: blur(5px);
      filter: blur(5px);
  } */
</style>



// WEBPACK FOOTER //
// src/containers/Full.vue?7310bc96